module.exports = __webpack_public_path__ + "media/images/desktop-newsletter-16dafa1b324579eecfc3d8f8e01c999e.png";